export const filterGroups = [
  {
    label: 'System filters',
    options: [
      { label: 'Inbox', value: 'inbox', query: { filter: 'inbox' } },
      { label: 'Sent', value: 'sent', query: { filter: 'sent' } },
      { label: 'Unread', value: 'unread', query: { filter: 'unread' } },
      { label: 'Archived', value: 'archived', query: { filter: 'archived' } },
    ],
  },
  {
    label: 'FactorStreet',
    options: [
      { label: 'hr@factorstreet.com', value: 'factorstreet_hr', query: { domain: 'factorstreet.com', mailbox: 'hr', address: 'hr@factorstreet.com' } },
      { label: 'admin@factorstreet.com', value: 'factorstreet_admin', query: { domain: 'factorstreet.com', mailbox: 'admin', address: 'admin@factorstreet.com' } },
      { label: 'hello@factorstreet.com', value: 'factorstreet_hello', query: { domain: 'factorstreet.com', mailbox: 'hello', address: 'hello@factorstreet.com' } },
    ],
  },
  {
    label: 'DevX Factor',
    options: [
      { label: 'hello@devxfactor.com', value: 'devxfactor_hello', query: { domain: 'devxfactor.com', mailbox: 'hello', address: 'hello@devxfactor.com' } },
      { label: 'support@devxfactor.com', value: 'devxfactor_support', query: { domain: 'devxfactor.com', mailbox: 'support', address: 'support@devxfactor.com' } },
      { label: 'admin@devxfactor.com', value: 'devxfactor_admin', query: { domain: 'devxfactor.com', mailbox: 'admin', address: 'admin@devxfactor.com' } },
    ],
  },
  {
    label: 'PhysicsFactor',
    options: [
      { label: 'hello@physicsfactor.com', value: 'physicsfactor_hello', query: { domain: 'physicsfactor.com', mailbox: 'hello', address: 'hello@physicsfactor.com' } },
      { label: 'support@physicsfactor.com', value: 'physicsfactor_support', query: { domain: 'physicsfactor.com', mailbox: 'support', address: 'support@physicsfactor.com' } },
      { label: 'admin@physicsfactor.com', value: 'physicsfactor_admin', query: { domain: 'physicsfactor.com', mailbox: 'admin', address: 'admin@physicsfactor.com' } },
    ],
  },
  {
    label: 'Other',
    options: [
      { label: 'General / Other', value: 'general', query: { filter: 'general' } },
      { label: 'Failed', value: 'failed', query: { filter: 'failed' } },
      { label: 'Marketing', value: 'marketing', query: { filter: 'marketing' } },
      { label: 'Unsubscribes', value: 'unsubscribes' },
    ],
  },
];

export const filterOptions = filterGroups.flatMap((group) => group.options);

export const emailTypeOptions = [
  { label: 'Candidate', value: 'candidate' },
  { label: 'Client', value: 'client' },
  { label: 'General', value: 'general' },
];

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const DEFAULT_CC = 'satyamquestapps@gmail.com';
export const MAILBOX_EMAILS = {
  hr: 'hr@factorstreet.com',
  admin: 'admin@factorstreet.com',
  hello: 'hello@factorstreet.com',
  support: 'support@devxfactor.com',
  general: 'General / Other',
};
export const FACTORSTREET_LOGO_SRC = '/fs_r_192px.png';

const MAILBOX_LABELS = {
  hr: 'HR',
  admin: 'Admin',
  hello: 'Hello',
  support: 'Support',
  general: 'General',
  marketing: 'Marketing',
  unknown: 'Unknown',
};

export function formatDate(value) {
  if (!value) return 'Not available';

  return new Intl.DateTimeFormat('en-IN', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
}

export function formatAddress(address) {
  if (!address) return 'Not available';
  return address.name ? `${address.name} <${address.email}>` : address.email;
}

export function getAddressEmail(address) {
  if (!address) return '';
  if (typeof address === 'string') return address.trim().toLowerCase();
  return String(address.email || '').trim().toLowerCase();
}

export function getAddressName(address) {
  if (!address || typeof address === 'string') return '';
  return String(address.name || '').trim();
}

export function getAddressInitials(address) {
  const name = getAddressName(address);
  const email = getAddressEmail(address);
  const source = name || email.split('@')[0] || 'FS';
  const words = source
    .replace(/[^a-z0-9\s._-]/gi, ' ')
    .split(/[\s._-]+/)
    .filter(Boolean);

  if (!words.length) return 'FS';

  return words
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join('');
}

export function isInternalFactorStreetAddress(address) {
  const email = getAddressEmail(address);
  const internalEmails = new Set([
    'hr@factorstreet.com',
    'admin@factorstreet.com',
    'hello@factorstreet.com',
    'hello@devxfactor.com',
    'support@devxfactor.com',
    'admin@devxfactor.com',
    'hello@physicsfactor.com',
    'support@physicsfactor.com',
    'admin@physicsfactor.com',
  ]);

  return (
    (email.endsWith('@factorstreet.com') ||
      email.endsWith('@devxfactor.com') ||
      email.endsWith('@physicsfactor.com')) &&
    internalEmails.has(email)
  );
}

export function formatAddressList(addresses = []) {
  if (!addresses.length) return 'None';
  return addresses.map(formatAddress).join(', ');
}

export function getEmailSnippet(email) {
  const text = email.text || String(email.html || '').replace(/<[^>]+>/g, ' ');

  return String(text || '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 150);
}

export function formatMailbox(mailbox) {
  if (!mailbox) return 'Unknown';
  return MAILBOX_LABELS[mailbox] || mailbox.charAt(0).toUpperCase() + mailbox.slice(1);
}

export function formatMailboxAddress(emailOrMailbox) {
  if (emailOrMailbox && typeof emailOrMailbox === 'object') {
    if (emailOrMailbox.recipientAddress) return emailOrMailbox.recipientAddress;
    if (emailOrMailbox.domain && emailOrMailbox.mailbox && !['general', 'marketing', 'unknown'].includes(emailOrMailbox.mailbox)) {
      return `${emailOrMailbox.mailbox}@${emailOrMailbox.domain}`;
    }

    return MAILBOX_EMAILS[emailOrMailbox.mailbox] || formatMailbox(emailOrMailbox.mailbox);
  }

  return MAILBOX_EMAILS[emailOrMailbox] || formatMailbox(emailOrMailbox);
}

export function formatEmailMailbox(email) {
  if (email?.recipientAddress) return email.recipientAddress;
  if (email?.domain && email?.mailbox && !['general', 'marketing', 'unknown'].includes(email.mailbox)) {
    return `${email.mailbox}@${email.domain}`;
  }

  return formatMailbox(email?.mailbox);
}

export function getEmailFilterQuery(value) {
  const option = filterOptions.find((item) => item.value === value);
  return option?.query || { filter: value };
}

export function parseRecipientPreview(value) {
  const rawEmails = String(value || '')
    .split(/[\n,;]+/)
    .map((entry) => {
      const trimmed = entry.trim();
      const match = trimmed.match(/^(.*?)<([^<>]+)>$/);
      return (match ? match[2] : trimmed).trim().toLowerCase();
    })
    .filter(Boolean);
  const seen = new Set();
  const duplicateEmails = [];
  const uniqueEmails = [];

  rawEmails.forEach((email) => {
    if (seen.has(email)) {
      duplicateEmails.push(email);
      return;
    }

    seen.add(email);
    uniqueEmails.push(email);
  });

  return {
    validEmails: uniqueEmails.filter((email) => EMAIL_PATTERN.test(email)),
    invalidEmails: uniqueEmails.filter((email) => !EMAIL_PATTERN.test(email)),
    duplicateEmails: Array.from(new Set(duplicateEmails)),
  };
}
